var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 167,
    viewBox: "0 0 226 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#GooglePay_svg__filter0_d_353_4628)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.323,
    y: 21.323,
    width: 182.562,
    height: 124.354,
    rx: 14.552,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2.646
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.472 103.386V87.4h8.251c3.381 0 6.234-1.132 8.56-3.367l.559-.566c4.249-4.626 3.97-11.832-.559-16.112a11.775 11.775 0 00-8.56-3.43h-13.245v39.461h4.994zm.001-20.832V68.771h8.376a6.76 6.76 0 014.777 1.951c2.699 2.644 2.761 7.05.155 9.787a6.484 6.484 0 01-4.932 2.045h-8.376zm40.663-4.06c-2.14-1.982-5.056-2.989-8.747-2.989-4.746 0-8.313 1.763-10.67 5.256l4.404 2.8c1.613-2.391 3.816-3.587 6.607-3.587a7.2 7.2 0 014.808 1.856 5.951 5.951 0 012.047 4.5v1.165c-1.923-1.07-4.342-1.636-7.32-1.636-3.474 0-6.266.818-8.344 2.486-2.078 1.667-3.133 3.87-3.133 6.67a8.398 8.398 0 002.947 6.609c1.954 1.762 4.436 2.643 7.351 2.643 3.443 0 6.173-1.542 8.251-4.625h.217v3.744h4.777V86.74c0-3.493-1.055-6.263-3.195-8.245zm-13.554 19.92a4.102 4.102 0 01-1.644-3.304c0-1.479.682-2.706 2.016-3.681 1.365-.976 3.072-1.48 5.088-1.48 2.792-.031 4.964.598 6.515 1.857 0 2.14-.838 3.997-2.482 5.57a7.88 7.88 0 01-5.615 2.36 6.045 6.045 0 01-3.878-1.322zm27.481 16.836l16.687-38.864h-5.428l-7.723 19.385h-.093l-7.91-19.385h-5.428l10.949 25.27-6.203 13.594h5.149z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.232 83.939c0-1.542-.124-3.084-.373-4.594H68.8v8.716h12.065c-.496 2.8-2.109 5.318-4.466 6.892v5.664h7.196c4.218-3.934 6.638-9.755 6.638-16.678z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8 106.093c6.017 0 11.104-2.014 14.795-5.476l-7.196-5.664c-2.016 1.384-4.59 2.171-7.6 2.171-5.83 0-10.763-3.996-12.53-9.346h-7.414v5.853c3.785 7.647 11.508 12.462 19.944 12.462z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.27 87.778c-.931-2.8-.931-5.853 0-8.685V73.27h-7.415a22.753 22.753 0 000 20.329l7.414-5.822z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8 69.747a11.926 11.926 0 018.56 3.398l6.39-6.482c-4.063-3.84-9.398-5.947-14.95-5.884-8.437 0-16.16 4.846-19.945 12.492l7.414 5.853c1.767-5.38 6.7-9.377 12.53-9.377z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "GooglePay_svg__filter0_d_353_4628",
    x: 0,
    y: 0,
    width: 225.208,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4628"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_353_4628",
    result: "shape"
  })))));
}
export default SvgGooglePay;